// import "channels/job_status_channel"

require("turbolinks").start()

import $ from 'jquery';
import 'jquery-ujs';
window.jQuery = $;
window.$ = $;
require("@nathanvda/cocoon")
import "chartkick/chart.js";
import "./stops";
import "./admin/trip_descriptions";
import "../stylesheets/ts_transit_application"

document.addEventListener("turbolinks:load", function () {
    $('input[type="checkbox"].all-siblings-selector')
        .on('click', function (event) {
            if ($(this).attr('data-target')) {
                let checkboxes = $(this).closest('form').find('input[type="checkbox"].' + $(this).attr('data-target'));
                checkboxes.prop("checked", $(this).prop("checked"));
            }
        })
});

document.addEventListener('turbolinks:load', function() {
    $('.gtfs_form #pill-local-tab').click(function() {
        $('input#docsrc_internet').prop('checked', false);
        $('input#docsrc_local').prop('checked', true);
    });
    $('.gtfs_form #pill-internet-tab').click(function() {
        $('input#docsrc_local').prop('checked', false);
        $('input#docsrc_internet').prop('checked', true);
    });
});
